import { Stack } from '@mui/material';
import { FC } from 'react';
import { ThemedSkeleton } from '@focuslee/shared-mini-app';
export type QuestSectionSkeletonProps = {
  itemCount?: number;
};

export const QuestSectionSkeleton: FC<QuestSectionSkeletonProps> = ({ itemCount = 3 }) => {
  return (
    <Stack gap={1}>
      <Stack flex={1} justifyContent="space-between" direction="row">
        <ThemedSkeleton 
          variant="text" 
          width={100} 
          height={25} 
        />
        <ThemedSkeleton 
          variant="text" 
          width={100} 
          height={25} 
        />
      </Stack>
      <Stack gap={1}>
        {Array.from({ length: itemCount }).map((_, i) => (
          <ThemedSkeleton 
            key={i} 
            variant="rectangular" 
            width="100%" 
            height={60} 
            sx={{ borderRadius: '8px' }} 
          />
        ))}
      </Stack>
    </Stack>
  );
};

